import TabsHolder from './TabsHolder';

export default TabsHolder;
